export default __webpack_public_path__ + "static/media/arrowRight.42107970.png";